import React from 'react';
import IStepProps from "./IStepProps";

const Step = ({children, changeStep}: IStepProps) => {
    return React.cloneElement(children, {changeStep})
};

export default Step;